// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MobilePhoneBase: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#fff",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 9 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M2.35 1.25c-.442 0-.8.335-.8.75v9c0 .415.358.75.8.75h4.8c.443 0 .8-.335.8-.75V2c0-.415-.357-.75-.8-.75zM.75 2c0-.827.717-1.5 1.6-1.5h4.8c.882 0 1.6.673 1.6 1.5v9c0 .827-.718 1.5-1.6 1.5h-4.8c-.883 0-1.6-.673-1.6-1.5zm3.2 7.875h1.6c.22 0 .4.169.4.375s-.18.375-.4.375h-1.6c-.22 0-.4-.169-.4-.375s.18-.375.4-.375"
            />
        </svg>
    );
};

export default React.memo(MobilePhoneBase);
